<template>
  <xt-dialog title="验证码" type="confirm" confirm-text="立即验证" no-button :visible="visible" @cancel="close">
    <div class="xt-message-wx">
      <div class="xt-message__subtitle">验证码已发送到您尾号为{{ tailNumber }}的手机</div>
      <el-input v-model.trim="newCode" type="tel" @input="onEnter" maxlength="6" placeholder="输入6位验证码"
                :class="{'actived':inputFocusLight}" @focus="inputFocusLight=true" @blur="inputFocusLight=false">
        <template slot="append">
          <el-button :class="{'actived':!waitSecond,'enable':waitSecond}" style="width:90px;text-align: right;padding-right: 8px;font-weight: normal;" type="text" :disabled="waitSecond>0" @click="sendMessage" v-track-click="{eventId: 'againSendMoblie', title: '身份验证-重新发送验证码'}">
            重新发送{{ `${waitSecond ? waitSecond : ''}` }}
          </el-button>
        </template>
      </el-input>
      <div :class="!errorMessage?'xt-message__error':'xt-message__error__active'">{{ errorMessage }}</div>
      <div  :class="{'show-voice-div':true,'show-voice-div-err':errorMessage}">
        没收到短信？点击获取
        <span :class="{'content-voice-link':true,'actived':!waitSecondVoice,'enable':waitSecondVoice}" @click="sendVoiceCode" v-track-click="{eventId: 'verifyVoiceCodeMobile', title: '身份验证-语音验证码'}">语音验证码</span>
      </div>
      <div class="xt-message__no-code">
        <span @click="isCallTel()" v-track-click="{eventId: 'verifyIsCallTelMobile', title: '身份验证-联系客服'}">联系客服</span>
      </div>
    </div>
    <xt-dialog :visible="showDialog" type="confirm" confirm-text="拨号" cancel-text="取消" @cancel="showDialog = false" @confirm="confirm()">
      <div style="text-align: center;margin: 20px 0;">
        {{TelAndWorkdayTimeText}}
      </div>
    </xt-dialog>
  </xt-dialog>
</template>
<script>
import {sendMessage, verifyMessage, sendVoiceMessage} from "@/service/support";
import XtDialog from "./xtDialog";
import {userInfo} from "@/service/user";
import {TelAndWorkdayTimeText} from "@/common/constant";
import { getFailCount } from "../service/login";
import { CAPTCHA_DATA } from "@/common/webTracing";

export default {
  components: {XtDialog},
  props: {
    mobileProp: {
      type: String,
      default: null
    },
    userName: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'redeem'
    },
    onSend: {
      type: Function,
      required: false
    },
    onVerify: {
      type: Function,
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    onSendVoice: {
      type: Function,
      required: false
    },
  },
  watch: {
    code: {
      handler(newValue) {
        this.code = ''
        let isEnter = newValue.length > 0
        if (isEnter) {
          if (!/^[0-9]+$/.test(newValue)) {
            newValue = null
            return
          }
          this.onEnter(newValue)
        }
      }
    },
    visible: {
     async handler(newValue) {
        if (newValue) {
          let count = 0
          if (this.userName) {
             count = await getFailCount(this.userName)
          }
          if (count >= 3) {
            this.initTimer()
          } else {
            this.loadMobile().then(() => {
              this.sendMessage()
            })
          }
        } else {
          //清除掉之前的定时器
          this.timer && clearInterval(this.timer)
          this.voiceTimer && clearInterval(this.voiceTimer)
        }
      }
    }
  },
  computed: {
    tailNumber() {
      return this.mobile.substring(this.mobile.length - 4)
    },
    mobile() {
      if (this.mobileProp) {
        return this.mobileProp
      }
      return this.mobileOfUser
    }
  },
  data() {
    return {
      curIndex: 0,
      waitSecond: 60,
      waitSecondVoice: 0,
      showErrorMessage: false,
      errorMessage: '',
      mobileOfUser: '',
      onStart: true,
      code: '',
      showDialog: false,
      sendStart: false,
      lastVerifyParams: "",
      newCode: '',
      timer: null,
      voiceTimer: null,
      inputFocusLight:false,
      TelAndWorkdayTimeText:TelAndWorkdayTimeText
    }
  },
  methods: {
    onEnter(string) {
      this.errorMessage = ''
      if (this.newCode && this.newCode.length === 6) {
        this.enteredCodes()
      } else {
        // this.newCode && (this.errorMessage = '请填写6位验证码')
      }
    },
    initTimer() {
      // this.waitSecond = 60
      // this.decreaseWaitTime()
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.waitSecond = 60
      this.timer = setInterval(() => {
        this.waitSecond--
        if (this.waitSecond <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    /**
     * 语音倒计时
     */
    initTimerVoice() {
      if (this.voiceTimer) {
        clearInterval(this.voiceTimer)
      }
      this.waitSecondVoice = 60
      this.voiceTimer = setInterval(() => {
        this.waitSecondVoice--
        if (this.waitSecondVoice <= 0) {
          clearInterval(this.voiceTimer)
          this.voiceTimer = null
        }
      }, 1000)
    },
    async enteredCodes() {
      if (this.lastVerifyParams === JSON.stringify({mobile: this.mobile, code: this.newCode})) {
        console.error("重复使用同一验证码获取token")
        this.lastVerifyParams = ""
        return
      }
      let response = await this.verifyCode()
      if (typeof response === 'object') {
        if (Number(response.code) === 200) {
          this.errorMessage = ''
          this.success()
        } else {
          console.error('异常返回', response)
          this.lastVerifyParams = ""
          this.errorMessage = response.message || '验证码错误'
          this.showErrorMessage = true
        }
      } else if (response === 'success') {
        this.success()
        this.errorMessage = ''
      } else {
        this.errorMessage = '验证码错误'
      }
    },
    async sendMessage() {
      this.errorMessage = ''
      this.initTimer()
      this.waitSecondVoice = 0
      try {
        this.$tracingTrace(CAPTCHA_DATA.smsCaptcha);
        if (this.onSend && typeof this.onSend === 'function') {
          await this.onSend(this.mobile)
        }else {
            await sendMessage(this.type)
          }
      } catch (error) {
        if (error.code === '5') {
          this.errorMessage = '获取验证码失败，请重新获取'
        }
      }

    },
    /**
     * 发送语音验证码
     */
    async sendVoiceCode() {
      if (this.waitSecondVoice == 60 || this.waitSecondVoice == 0) {
        this.errorMessage = ''
        this.initTimerVoice();
        try {
          this.$tracingTrace(CAPTCHA_DATA.voiceCaptcha);
          if (this.onSendVoice && typeof this.onSendVoice === 'function') {
            await this.onSendVoice(this.mobile)
          } else {
            await sendVoiceMessage(this.type);
          }
        } catch (error) {
          if (error.code === '5') {
            this.errorMessage = '获取验证码失败，请重新获取'
          }
        }
      }
    },

    async isCallTel() {
      this.showDialog = true
    },
    async confirm() {
      this.showDialog = false
      this.callTel()
    },
    async verifyCode() {
      let codes = this.newCode
      if (this.onVerify && typeof this.onVerify === 'function') {
        this.lastVerifyParams = JSON.stringify({mobile: this.mobile, code: codes})
        return await this.onVerify({mobile: this.mobile, code: codes})
      } else {
        return await verifyMessage({mobile: this.mobile, areaCode: codes, type: this.type})
      }
    },
    async loadMobile() {
      if (!this.mobileProp) {
        let userData = await userInfo()
        this.$store.commit('updateMobile', userData.mobile)
        this.mobileOfUser = userData.mobile
      }
    },
    moveEnd(obj) {
      obj.focus();
      let len = obj.value.length;
      if (document.selection) {
        let sel = obj.createTextRange();
        sel.moveStart('character', len);
        sel.collapse();
        sel.select();
      } else if (typeof obj.selectionStart == 'number'
          && typeof obj.selectionEnd == 'number') {
        obj.selectionStart = obj.selectionEnd = len;
      }
    },
    success() {
      this.$emit('success')
    },
    close() {
      if (this.type === 'login') {
        this.onStart = true
        this.waitSecond = 60;
        this.newCode = ''
      }
      this.$emit('close')
    },
    reset() {
      this.newCode = ''
      this.sendMessage()
    }
  },
  async mounted() {
    this.lastVerifyParams = ""
  }
}
</script>
<style lang="less">
@defaultFontSize:16px;
.xt-message-wx {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  min-width: 263px;

  > div {
    width: 263px;
  }

  .xt-message__subtitle {
    margin-bottom: 8px;
    font-weight: 400;
    font-size: @defaultFontSize;//14px;
    line-height: @defaultFontSize;//14px;
    color: #8C8C8C;
    text-align: left;
    margin-top: 12px;
    //width: 281px;
  }

  .el-input {
    border: 1px solid #eee;
    border-radius: 3px;
    &.actived{
      border-color: rgba(100,150,219,0.8);
    }
    &.el-input-group--append {
      .el-input__inner {
        border: 0;
      }
      .el-input-group__append {
        background-color: #fff;
        border: 0;
        .el-button {
          border: 0;
          &.actived {
            span {
              color: #6496DB !important;
            }
          }

          &.enable {
            span {
              color: #8C8C8C !important;
            }
          }
        }
      }
    }
    input::-webkit-input-placeholder {
     font-weight: 400;
    }
  }

  .xt-message__error {
    margin: 4px 0;
  }
  .xt-message__error__active{
    height: @defaultFontSize;//16px;
    line-height: @defaultFontSize;//16px;
    font-weight: 400;
    font-size: @defaultFontSize;//12px;
    color: #FF0000;
    text-align: left;
    margin: 6px 0;
  }

  .show-voice-div {
    font-weight: 400;
    font-size: @defaultFontSize;//14px;
    line-height: 18px;
    color: #505050;
    text-align: left;
    margin: 12px 0;
  }
  .show-voice-div-err{
    margin: 0;
    margin-bottom: 10px;
  }

  .content-voice-link {
    text-decoration: underline;
    color: #497AC0;

    &.actived {
      color: #6496DB !important;
      cursor: pointer;
    }

    &.enable {
      color: #8C8C8C !important;

      &:hover {
        color: #6496DB;
      }
    }
  }

  .xt-message__no-code {
    text-align: left;
    font-weight: 400;
    font-size:  @defaultFontSize;//14px;
    line-height:  @defaultFontSize;//14px;
    color: #6496DB;
    //margin-top: 10px;
  }
}
</style>
